module.exports = __webpack_public_path__ + "b2b6d7e31add342982d340d765b4c733.svg";